import { envToBoolean } from '@/helpers/utils';

export const isVerificationEnabled = envToBoolean(import.meta.env.VITE_FEATURE_FLAG_VERIFICATION);
export const isBlockSenderEnabled = envToBoolean(import.meta.env.VITE_FEATURE_FLAG_BLOCK_SENDER);
export const isMcpServerEnabled = envToBoolean(import.meta.env.VITE_FEATURE_FLAG_MCP);
